
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/listings/[id]",
      function () {
        return require("private-next-pages/listings/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/listings/[id]"])
      });
    }
  